import Debug from './Utils/Debug.js'
import Sizes from './Utils/Sizes.js'
import Time from './Utils/Time.js'
import { isMobile } from './Utils/Device.js'
import World from './World/World.js'
import config from './config.js'

let instance = null

export default class Experience {
    constructor() {
        // Singleton
        if (instance) {
            return instance
        }
        instance = this

        // Global access
        window.experience = this

        this.debug = new Debug()

        this.config = config

        this.initUtilities()
        this.initWorld()
    }

    initUtilities() {
        this.isMobile = isMobile();
        this.sizes = new Sizes()
        this.time = new Time()
    }

    load() {
    }

    initCore() {
    }

    initWorld() {
        this.world = new World()
    }

    initUI() {
    }

    initEvents() {
        this.sizes.on('resize', () => {
            this.resize()
        })

        this.time.on('tick', () => {
            this.update()
        })
    }

    resize() {
    }

    update() {

    }

    playIntro() {
 
    }
}